

export default function VariantItem({ name, price, variantId, id }){
    return (
        <div className="variation-item">
            <div>{name}</div>
            <div>{price} tk</div>
        </div>
    )
}